import { getBackendUrl } from "@Utils";
import axiosWrapper from "@AxiosWrapper";
import type {
  ProjectTemplateControllerRequest,
  ProjectTemplateControllerResponse,
} from "@ServerTypes/projectTemplates/projectTemplates.schema";
import type { ObjectIdString } from "@Helpers/schemas/common.schema";

/**
 * One row of the Project Templates grid.
 *
 * SERVER GAP: `projectTemplateControllerResponse.result[]` declares only `_id`/`name`/
 * `description`, but `projectTemplateData` also returns `updatedDate` and `updatedBy` and the
 * grid renders both as columns. The two undeclared fields are added here so `_id`/`name`/
 * `description` stay sourced from the server schema instead of being re-declared by hand.
 */
export type ProjectTemplateRow = NonNullable<ProjectTemplateControllerResponse["result"]>[number] & {
  updatedDate?: number;
  /** `_id` is the account id of the last editor, rendered by renderUserTag. */
  updatedBy?: { _id?: ObjectIdString; name?: string };
};

export async function getProjectTemplatesData({ value }: { value: ProjectTemplateControllerRequest["value"] }) {
  const response = await axiosWrapper.post<ProjectTemplateControllerResponse>(
    `${getBackendUrl()}/projectTemplates/projectTemplateData`,
    { value },
  );
  return response.data.result;
}
